import axios from 'axios'
import { getUserInfo } from '@/utils/common'

// postForm请求
let httpForm = axios.create({
    baseURL: '/api/',
    withCredentials: true,
    changeOrigin: true,
    timeout: 30000, // 请求超时时间 
    transformRequest: [function (data) {
    let newData = ''
    for (let k in data) {
        if (data.hasOwnProperty(k) === true) {
            newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
        }
    }
    return newData;
    }]
});

// postJson请求
let httpJson = axios.create({
    baseURL: '/api/',
    withCredentials: true,
    changeOrigin: true,
    timeout: 30000, // 请求超时时间 
});

function apiAxiosForm(method, url, params) {
    return httpForm({
        method: method,
        url: url,
        headers: {
            'Content-Type':'application/x-www-form-urlencoded',
            'X-token':getUserInfo().token,
            'X-uid':getUserInfo().uid
        },
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
    })
}

function apiAxiosJson(method, url, params) {
    return httpJson({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-token':getUserInfo().token,
            'X-uid':getUserInfo().uid
        },
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
    })
}

export default {
    get: function (url, apiType, params, response) {
        if(apiType === 'Json')
            return apiAxiosJson('GET', url, params, response)
        else 
            return apiAxiosForm('GET', url, params, response)
    },
    post: function (url, apiType, params, response) {
        if(apiType === 'Json')
            return apiAxiosJson('POST', url, params, response)
        else 
            return apiAxiosForm('POST', url, params, response)
    },
    put: function (url, params, response) {
        if(apiType === 'Json')
            return apiAxiosJson('PUT', url, params, response)
        else 
            return apiAxiosForm('PUT', url, params, response)
    },
    delete: function (url, params, response) {
        if(apiType === 'Json')
            return apiAxiosJson('DELETE', url, params, response)
        else 
            return apiAxiosForm('DELETE', url, params, response)
    }
}